import { brand } from '@/content/site';
import styles from './Logo.module.css';

/** Wordmark + mark. Rendered as a link back to the top of the page. */
export function Logo() {
  return (
    <a href="#top" className={styles.logo} aria-label={`${brand.name} — home`}>
      <span className={styles.mark} aria-hidden="true" />
      <span className={styles.word}>
        qvantum<b>-os</b>
      </span>
    </a>
  );
}
